<!--
data: {
    content: '内容',
    list: ['按钮一','按钮二']
}
-->
<template>
	<section class="dialog">
		<div class="dia-con">
			<p v-if="title">{{title}}</p>
			<p v-html="data.content" v-if='data.content' />
			<slot v-else></slot>
			<div v-if="data.list.length > 1" class="dia-btn tBor">
				<a @click="tapBtn(0)" v-text="data.list[0]" />
				<a class="lBor" @click="tapBtn(1)" v-text="data.list[1]" />
			</div>
            <div v-else class="dia-btn dia-btn1 tBor">
				<a @click="tapBtn(2)" v-text="data.list[0]" />
			</div>
		</div>
	</section>
</template>
<script>
	export default {
		data() {
			return {
				flag: -1
			}
		},

		props: {
			data: {
				type: Object,
				default: () => {}
			},
			title: {
				type: String,
				default: ""
			}
		},
		methods: {
			//点击按钮
			tapBtn(index) {
				this.$emit('tapBtn', index);
			}
		}
	}
</script>

<style scoped>
	@import "../assets/css/onePx.css";

	.dialog {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.3);
		position: fixed;
		top: 0;
		left: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.dia-con {
		width: 6.6rem;
		height: auto;
		background-color: #FFF;
		border-radius: 0.1rem;
	}

	.dia-con p {
		padding: 0.48rem 0.3rem 0.48rem 0.3rem;
		line-height: 0.48rem;
		font-size: 0.32rem;
		color: #333;
		word-break: break-all;
	}

	.dia-btn {
		height: 1rem;
		position: relative;
	}

	.dia-btn a {
		width: 50%;
		line-height: 1rem;
		text-align: center;
		font-size: 0.32rem;
		color: #333;
		float: left;
	}

    .dia-btn1 a{ width: 100%;}

	.dia-btn a+a {
		color: #ED7D31;
		position: relative;
	}
</style>
